
// 'options':{
//   url:'',
//   body:{},
//   data:{},
//   loading:flase 
// }

export const find = (options) => ({
    type: 'find',
    options: options
})

export const del = (options) => ({
    type: 'del',
    options: options
})

export const update = (options) => ({
    type: 'del',
    options: options
})

export const add = (options) => ({
    type: 'del',
    options: options
})


// WEBPACK FOOTER //
// ./actions/base.js